<template>
  <v-container>
    <v-card elevation="3" flat class="rounded-lg">
      <v-card-text>
        <v-form ref="logForm" lazy-validation>
          <v-row>
            <v-col cols="12" class="pb-0">
              <v-select
                v-model="subject"
                :items="subjects"
                label="Asunto"
                dense
                outlined
                background-color="white"
                :rules="[(v) => !!v || 'El asunto es requerido']"
                required
              ></v-select>
            </v-col>

            <v-col cols="6">
              <v-row>
                <span class="ml-3 sample--date">
                  {{ date }}
                </span>
                <div class="ml-1">
                  <v-icon @click.stop="showDialog = true" color="#fb8c00"
                    >mdi-calendar</v-icon
                  >
                </div>
              </v-row>
            </v-col>
            <!-- <v-col cols="6" v-if="!newLog">
              <v-row class="d-flex justify-end mr-1">
                <div
                  style="background-color: #ff5722; border-radius: 7px"
                  class="mr-1"
                >
                  <v-icon
                    @click="deleteCurrentImage"
                    color="#FFFF"
                    style="font-size: 20px"
                    class="ma-1"
                    >mdi-trash-can</v-icon
                  >
                </div>
                <div style="background-color: #027223; border-radius: 7px">
                  <v-icon
                    @click="goToTakePicture"
                    color="#FFFF"
                    style="font-size: 20px"
                    class="ma-1"
                    >mdi-plus</v-icon
                  >
                </div>
              </v-row>
            </v-col> -->
            <!-- Carousel images -->
            <v-col cols="12" xl="8" lg="8">
              <v-carousel
                :show-arrows="true"
                height="auto"
                v-model="currentIndex"
                v-if="this.$vuetify.breakpoint.name == 'xs'"
              >
                <v-carousel-item
                  v-for="(evidence, i) in evidences_de"
                  :key="i"
                  :src="evidence.img"
                >
                </v-carousel-item>
              </v-carousel>

              <v-carousel
                :show-arrows="true"
                height="auto"
                v-model="currentIndex"
                v-else
              >
                <v-carousel-item v-for="(evidence, i) in evidences_de" :key="i">
                  <v-img :src="evidence.img" contain aspect-ratio="1.2">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-carousel-item>
              </v-carousel>
            </v-col>
            <!-- Description -->
            <v-col cols="12" xl="4" lg="4">
              <v-textarea
                v-model="description"
                outlined
                label="Descripción"
                hint="Escribe una descripción"
                :rules="[(v) => !!v || 'La descripción es requerida']"
                required
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <dialog-date-picker
      v-model="showDialog"
      @picker="getDate"
    ></dialog-date-picker>
    <v-dialog v-model="dialog" max-width="270">
      <v-card>
        <v-card-text class="pa-4 text-center" style="display: grid">
          <v-icon large color="primary">mdi-information-outline</v-icon>
          Al menos debe de tomar una evidencia fotográfica
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="green darken-1" text @click="dialog = false">
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <!-- copyright -->
    <v-footer class=" text-caption text-center d-flex justify-center"  fixed> D.R. © Solena Ag, Inc. {{new Date().getFullYear()}} </v-footer>
  </v-container>
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";

import moment from "moment";

// Components
import DialogDatePicker from "@/components/territory/modals/DialogDatePicker.vue";

export default {
  data() {
    return {
      dialog: false,
      showDialog: false,
      currentIndex: 0,
      subject: "",
      date: null,
      description: "",
      logBookType: "CLIENT",
      evidences_de: [],
      urls: [],
      validForm: null,
      newLog: true,
      subjects: [
        {
          text: "Otro",
          value: "Other",
        },
        {
          text: "Problema detectado",
          value: "Problem detected",
        },
        {
          text: "Aplicación de producto",
          value: "Product application",
        },
        {
          text: "Aplicación de producto SOLENA",
          value: "SOLENA product application",
        },
        {
          text: "Desarrollo Vegetativo",
          value: "Vegetative development",
        },
      ],
    };
  },
  watch: {
    subject(newVal, oldVal) {
      this.SET_SUBJECT(newVal);
    },
    description(newVal, oldVal) {
      this.SET_DESCRIPTION(newVal);
    },
    date(newVal, oldVal) {
      this.SET_DATE(newVal);
    },
  },
  components: {
    DialogDatePicker,
  },
  async created() {
    try {
      if (this.log_selected) {
        this.init();
      } else {
        let response = await this.geById(this.$route.params.logFieldId);
        if (response) {
          if (!response.error) {
            this.SET_LOG_SELECTED(response.logBook);
            this.init();
          } else {
            console.log(response.message);
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Algo salio mal al cargar bitácora !!, intente de nuevo",
              timeout: 4000,
            });
          }
        } else {
          this.SET_ALERT_TYPE({
            visible: true,
            type: "error",
            text: "Algo salio mal al cargar bitácora !!, intente de nuevo",
            timeout: 4000,
          });
        }
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text: "Algo salio mal al cargar bitácora !!, intente de nuevo",
        timeout: 4000,
      });
    }
  },
  computed: {
    ...mapState("logs", [
      "log_selected",
      "area_selected",
      "evidences",
      "subject_edit",
      "descripton_edit",
      "date_edit",
    ]),
  },
  methods: {
    ...mapMutations(["SET_APPBAR_OPTIONS", "SET_LOADER"]),
    ...mapMutations("logs", [
      "CLEAR_STATE",
      "SET_AREA_SELECTED_LOGS",
      "SET_EDIT",
      "SET_SUBJECT",
      "SET_DATE",
      "SET_DESCRIPTION",
      "CLEAR_STATE_LOG_LIST",
      "SET_LOG_SELECTED",
    ]),
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions(["uploadImage"]),
    ...mapActions("logs", ["createLogBook", "updateLogBook", "geById"]),
    init() {
      if (this.log_selected) {
        this.log_selected._id ? (this.newLog = false) : (this.newLog = true);
        this.evidences_de = this.log_selected.photographicEvidence;

        if (this.newLog) {
          this.SET_APPBAR_OPTIONS({
            leftButton: "back-arrow",
            funcLeftButton: this.goBack,
            // rightButton: !this.log_selected._id && "save",
            // funcRightButton: this.saveLogBook,
          });
          this.subject = this.log_selected.subject;
          this.date = this.getFormatted(this.log_selected.date);
          this.description = this.log_selected.description;
        } else {
          this.SET_APPBAR_OPTIONS({
            leftButton: "back-arrow",
            funcLeftButton: this.goBack,
            // rightButton: this.log_selected._id && "save",
            // funcRightButton: this.saveLogBook,
          });
          this.SET_EDIT(true);

          if (this.evidences.length > 0) {
            this.evidences_de.push(this.evidences[this.evidences.length - 1]);
          }
          if (this.subject_edit === "") {
            this.SET_SUBJECT(this.log_selected.subject);
            this.subject = this.log_selected.subject;
          } else {
            this.subject = this.subject_edit;
          }

          if (this.date_edit === null) {
            this.SET_DATE(this.getFormatted(this.log_selected.date));
            this.date = this.getFormatted(this.log_selected.date);
          } else {
            this.date = this.date_edit;
          }

          if (this.descripton_edit === "") {
            this.SET_DESCRIPTION(this.log_selected.description);
            this.description = this.log_selected.description;
          } else {
            this.description = this.descripton_edit;
          }
        }
      }
    },
    getFormatted(date) {
      return moment.utc(date).format("YYYY-MM-DD");
    },
    getFormattedDateDialog() {
      return moment(date).format("YYYY-MM-DD").add(1, "d");
    },
    // Convert captured photo to image file.
    dataURLtoFile(img) {
      let arr = img.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], "evidence.jpg", {
        type: mime,
      });
    },
    async saveLogBook() {
      if (this.newLog) {
        if (this.$refs.logForm.validate()) {
          this.SET_LOADER(true);
          try {
            //send images to S3
            for (let evidence of this.log_selected.photographicEvidence) {
              if (evidence.img != null && evidence.img != "") {
                let imgFile = this.dataURLtoFile(evidence.img);
                let form_data = new FormData();
                form_data.append("file", imgFile);
                const { urlImg } = await this.uploadImage(form_data);

                evidence.img = urlImg;
              } else {
                evidence.img = "";
              }
            }
            this.log_selected.subject = this.subject;
            this.log_selected.description = this.description;
            this.log_selected.date = this.date;

            await this.createLogBook(this.log_selected);
            this.CLEAR_STATE();
            this.SET_ALERT_TYPE({
              visible: true,
              type: "success",
              text: "Guardado",
              timeout: 4000,
            });
            this.$router.back();
          } catch (error) {
            this.SET_ALERT_TYPE({
              visible: true,
              type: "error",
              text: "Ha ocurrido un error, inténtalo de nuevo",
              timeout: 4000,
            });
          }
          this.SET_LOADER(false);
        }
      } else {
        if (this.$refs.logForm.validate()) {
          if (this.evidences_de.length > 0) {
            this.SET_LOADER(true);
            try {
              //send images to S3

              for (let evidence of this.evidences_de) {
                if (evidence.img != null) {
                  if (!evidence.img.startsWith("http") && evidence.img != "") {
                    let imgFile = this.dataURLtoFile(evidence.img);
                    let form_data = new FormData();
                    form_data.append("file", imgFile);
                    const { urlImg } = await this.uploadImage(form_data);

                    evidence.img = urlImg;
                  }
                } else {
                  evidence.img = "";
                }
              }

              this.log_selected.photographicEvidence = this.evidences_de;
              this.log_selected.subject = this.subject;
              this.log_selected.description = this.description;
              this.log_selected.date = this.date;

              await this.updateLogBook(this.log_selected);
              this.CLEAR_STATE_LOG_LIST();
              this.SET_ALERT_TYPE({
                visible: true,
                type: "success",
                text: "Guardado",
                timeout: 4000,
              });
              this.$router.push(`/logbook?fromAreaDetail=true`);
            } catch (error) {
              this.SET_ALERT_TYPE({
                visible: true,
                type: "error",
                text: "Ha ocurrido un error, inténtalo de nuevo",
                timeout: 4000,
              });
            }
            this.SET_LOADER(false);
          } else {
            this.dialog = true;
          }
        }
      }
    },
    goBack() {
      this.$router.back();
      //   if (this.$route.query.new) {
      //     this.newLog
      //       ? this.$router.push("/territory/addLogbook")
      //       : this.$router.push("/logbook");
      //   } else {
      //     this.CLEAR_STATE_LOG_LIST();
      //     this.SET_AREA_SELECTED_LOGS(this.area_selected);
      //     this.$router.push(`/logbook?fromAreaDetail=true`);
      //   }
    },
    goToTakePicture() {
      this.$router.push("/photoLogbook");
    },
    deleteCurrentImage() {
      this.evidences_de.splice(this.currentIndex, 1);
    },
    getDate(e) {
      this.date = this.getFormatted(e);
    },
  },
};
</script>

<style scoped>
.sample--date {
  font-size: 0.9rem;
  color: #818181;
}
</style>
